<div
  class="c-page-loader__animation--strip"
  *ngIf="resultLoader == true"
></div>
<div class="c-tariff__btn-container" *ngIf="getSelectedCount()">
  <div class="t-4 c-booking-stats__title">
    Tariff Results
  </div>
  <div class="c-tariff__btn-container">
    <div *ngFor="let option of downloadOptions" class="c-passenger-form__option-item">
      <label class="a-radio">
        <surf-radiobutton [selected]="option.selected" [name]="option.id" [id]="option.id" [lable]="option.label"
          [group]="'downloadOptions'" (status)="toggleState($event, option.id)">
        </surf-radiobutton>
      </label>
    </div>
    <button class="a-btn a-btn--primary a-tariff__download-btn auto-btn-select" (click)="downloadSelected()">
      Download Selected
    </button>
  </div>
</div>
<div
  class="o-results-table__tariffs c-booking-summery__results itinerary-results"
  *ngIf="
    modifiedResultList &&
    modifiedResultList.length > 0 &&
    resultLoader == false
  "
>
  <div class="o-result-table c-booking-results">
    <!-- table row title -->
    <div
      class="o-result-table__header--tariffs c-booking-results__header--tariffs"
    >
      <span class="o-result-table__header-item">
        <span
          class="c-result-table__header-title u-clickable"
          (click)="sortByHandler('name', $event)"
          [ngClass]="{
            'is-selected': sortBy === 'name' && sortDirection !== 'neutral'
          }"
        >
        <div class="c-results-tariff__select-all">
          <surf-checkbox
            [id]="checkboxId"
            (status)="toggleAllSelection()"
            [autoStatusChange]="false"
            [selected]="allDataSelected"
            [disabled]="false"
            [name]="'Hotel Name'"
            [textCase]="'title'"
            [customClass]="checkboxId"
          >
          </surf-checkbox>
        </div>
          <ng-container *ngIf="sortBy !== 'name'">
            <svg class="a-icon">
              <use xlink:href="#sort--all"></use>
            </svg>
          </ng-container>

          <ng-container *ngIf="sortDirection === 'asc' && sortBy === 'name'">
            <span
              class="a-tool-tip a-tool-tip--top-left c-result-table__header-sort"
              [attr.data-tooltip]="
                SurfFilterOptionTooltipValueEnum.ALPHABETICAL_ORDER
              "
            >
              <svg class="a-icon">
                <use xlink:href="#sort--ascending"></use>
              </svg>
            </span>
          </ng-container>

          <ng-container *ngIf="sortDirection === 'desc' && sortBy === 'name'">
            <span
              class="a-tool-tip a-tool-tip--top-left c-result-table__header-sort"
              [attr.data-tooltip]="
                SurfFilterOptionTooltipValueEnum.REVERSE_ALPHABETICAL_ORDER
              "
            >
              <svg class="a-icon">
                <use xlink:href="#sort--decending"></use>
              </svg>
            </span>
          </ng-container>
        </span>
      </span>

      <span class="o-result-table__header-item">
        <span
          class="c-result-table__header-title u-clickable"
          (click)="sortByHandler('city')"
          [ngClass]="{
            'is-selected': sortBy === 'city' && sortDirection !== 'neutral'
          }"
        >
          City

          <ng-container *ngIf="sortBy !== 'city'">
            <svg class="a-icon">
              <use xlink:href="#sort--all"></use>
            </svg>
          </ng-container>

          <ng-container *ngIf="sortDirection === 'asc' && sortBy === 'city'">
            <span
              class="a-tool-tip a-tool-tip--top-left c-result-table__header-sort"
              [attr.data-tooltip]="
                SurfFilterOptionTooltipValueEnum.ALPHABETICAL_ORDER
              "
            >
              <svg class="a-icon">
                <use xlink:href="#sort--ascending"></use>
              </svg>
            </span>
          </ng-container>

          <ng-container *ngIf="sortDirection === 'desc' && sortBy === 'city'">
            <span
              class="a-tool-tip a-tool-tip--top-left c-result-table__header-sort"
              [attr.data-tooltip]="
                SurfFilterOptionTooltipValueEnum.REVERSE_ALPHABETICAL_ORDER
              "
            >
              <svg class="a-icon">
                <use xlink:href="#sort--decending"></use>
              </svg>
            </span>
          </ng-container>
        </span>
      </span>

      <span class="o-result-table__header-item">
        <span
          class="c-result-table__header-title u-clickable"
          (click)="sortByHandler('resort')"
          [ngClass]="{
            'is-selected': sortBy === 'resort' && sortDirection !== 'neutral'
          }"
        >
          Resort

          <ng-container *ngIf="sortBy !== 'resort'">
            <svg class="a-icon">
              <use xlink:href="#sort--all"></use>
            </svg>
          </ng-container>

          <ng-container *ngIf="sortDirection === 'asc' && sortBy === 'resort'">
            <span
              class="a-tool-tip a-tool-tip--top-left c-result-table__header-sort"
              [attr.data-tooltip]="
                SurfFilterOptionTooltipValueEnum.ALPHABETICAL_ORDER
              "
            >
              <svg class="a-icon">
                <use xlink:href="#sort--ascending"></use>
              </svg>
            </span>
          </ng-container>

          <ng-container *ngIf="sortDirection === 'desc' && sortBy === 'resort'">
            <span
              class="a-tool-tip a-tool-tip--top-left c-result-table__header-sort"
              [attr.data-tooltip]="
                SurfFilterOptionTooltipValueEnum.REVERSE_ALPHABETICAL_ORDER
              "
            >
              <svg class="a-icon">
                <use xlink:href="#sort--decending"></use>
              </svg>
            </span>
          </ng-container>
        </span>
      </span>

      <span class="o-result-table__header-item">
        <span
          class="c-result-table__header-title u-clickable"
          (click)="sortByHandler('touristRegion')"
          [ngClass]="{
            'is-selected':
              sortBy === 'touristRegion' && sortDirection !== 'neutral'
          }"
        >
          Tourist Region

          <ng-container *ngIf="sortBy !== 'touristRegion'">
            <svg class="a-icon">
              <use xlink:href="#sort--all"></use>
            </svg>
          </ng-container>

          <ng-container
            *ngIf="sortDirection === 'asc' && sortBy === 'touristRegion'"
          >
            <span
              class="a-tool-tip a-tool-tip--top-left c-result-table__header-sort"
              [attr.data-tooltip]="
                SurfFilterOptionTooltipValueEnum.ALPHABETICAL_ORDER
              "
            >
              <svg class="a-icon">
                <use xlink:href="#sort--ascending"></use>
              </svg>
            </span>
          </ng-container>

          <ng-container
            *ngIf="sortDirection === 'desc' && sortBy === 'touristRegion'"
          >
            <span
              class="a-tool-tip a-tool-tip--top-left c-result-table__header-sort"
              [attr.data-tooltip]="
                SurfFilterOptionTooltipValueEnum.REVERSE_ALPHABETICAL_ORDER
              "
            >
              <svg class="a-icon">
                <use xlink:href="#sort--decending"></use>
              </svg>
            </span>
          </ng-container>
        </span>
      </span>

      <span class="o-result-table__header-item">
        <span
          class="c-result-table__header-title u-clickable"
          (click)="sortByHandler('starRating')"
          [ngClass]="{
            'is-selected':
              sortBy === 'starRating' && sortDirection !== 'neutral'
          }"
        >
          Star Rating

          <ng-container *ngIf="sortBy !== 'starRating'">
            <svg class="a-icon">
              <use xlink:href="#sort--all"></use>
            </svg>
          </ng-container>

          <ng-container
            *ngIf="sortDirection === 'asc' && sortBy === 'starRating'"
          >
            <span
              class="a-tool-tip a-tool-tip--top-left c-result-table__header-sort"
              [attr.data-tooltip]="
                SurfFilterOptionTooltipValueEnum.ALPHABETICAL_ORDER
              "
            >
              <svg class="a-icon">
                <use xlink:href="#sort--ascending"></use>
              </svg>
            </span>
          </ng-container>

          <ng-container
            *ngIf="sortDirection === 'desc' && sortBy === 'starRating'"
          >
            <span
              class="a-tool-tip a-tool-tip--top-left c-result-table__header-sort"
              [attr.data-tooltip]="
                SurfFilterOptionTooltipValueEnum.REVERSE_ALPHABETICAL_ORDER
              "
            >
              <svg class="a-icon">
                <use xlink:href="#sort--decending"></use>
              </svg>
            </span>
          </ng-container>
        </span>
      </span>

      <span class="o-result-table__header-item">
        <span
          class="c-result-table__header-title u-clickable"
          (click)="sortByHandler('ourRating')"
          [ngClass]="{
            'is-selected': sortBy === 'ourRating' && sortDirection !== 'neutral'
          }"
        >
          Our Rating

          <ng-container *ngIf="sortBy !== 'ourRating'">
            <svg class="a-icon">
              <use xlink:href="#sort--all"></use>
            </svg>
          </ng-container>

          <ng-container
            *ngIf="sortDirection === 'asc' && sortBy === 'ourRating'"
          >
            <span
              class="a-tool-tip a-tool-tip--top-left c-result-table__header-sort"
              [attr.data-tooltip]="
                SurfFilterOptionTooltipValueEnum.ALPHABETICAL_ORDER
              "
            >
              <svg class="a-icon">
                <use xlink:href="#sort--ascending"></use>
              </svg>
            </span>
          </ng-container>

          <ng-container
            *ngIf="sortDirection === 'desc' && sortBy === 'ourRating'"
          >
            <span
              class="a-tool-tip a-tool-tip--top-left c-result-table__header-sort"
              [attr.data-tooltip]="
                SurfFilterOptionTooltipValueEnum.REVERSE_ALPHABETICAL_ORDER
              "
            >
              <svg class="a-icon">
                <use xlink:href="#sort--decending"></use>
              </svg>
            </span>
          </ng-container>
        </span>
      </span>

      <span
        class="o-result-table__header-item o-result-table__header-item--end c-result-table__header-title"
      >Actions</span>
    </div>

    <!-- table row body - booking list view -->
    <div class="o-result-table__body" id="auto-select-booking">
      <!--NOTE: id for the paginate pipe should be equal to the id in surf-pagination-control component.-->
      <ng-container
        *ngFor="
          let record of modifiedResultList
            | paginate
              : {
                  id: 'surf-tariff-search' + componentId,
                  itemsPerPage: pageSize,
                  currentPage: pageNumber
                };
          let i = index
        "
      >
        <div
          class="o-result-table__row"
          [ngClass]="{
            'is-selected': record.selected
          }"
        >
          <div class="o-result-table__summary c-booking-results__row--tariffs">
            <!-- Hotel Name Column -->
            <div class="c-result-table__data">
              <span class="lbl u-visible-xm">Hotel Name</span>
              <surf-checkbox
                (status)="toggleSelection(record)"
                [autoStatusChange]="false"
                [selected]="record.selected"
                [disabled]="false"
                [name]="record.name"
                [textCase]="'title'"
                [customClass]="
                  'c-booking-results__lbl auto-link-booking-search-results c-result-table__value-txt c-result-table__value--price'
                "
              >
              </surf-checkbox>
            </div>
            <!-- City Column -->
            <div class="c-result-table__data">
              <span class="lbl u-visible-xm">City</span>
              <span
                class="c-booking-results__lbl auto-link-booking-search-results c-result-table__value-txt"
                surfTooltip [attr.title]="record.city | surfTextCase: 'title'"
                >{{ record.city }}</span
              >
            </div>
            <!-- Resort Column -->
            <div class="c-result-table__data">
              <span class="lbl u-visible-xm">Resort</span>
              <span
                class="c-booking-results__lbl auto-link-booking-search-results c-result-table__value-txt c-result-table__value--price"
                surfTooltip [attr.title]="record.resort | surfTextCase: 'title'"
                >{{ record.resort }}</span
              >
            </div>
            <!-- Tourist Region Column -->
            <div class="c-result-table__data">
              <span class="lbl u-visible-xm">Tourist Region</span>
              <span
                class="c-booking-results__lbl auto-link-booking-search-results c-result-table__value-txt c-tariff__tourist-region"
                surfTooltip [attr.title]="record.touristRegion | surfTextCase: 'title'"
                >{{ record.touristRegion }}</span
              >
            </div>
            <!-- Star Rating Column -->
            <div class="c-result-table__data">
              <span class="lbl u-visible-xm">Star Rating</span>
              <span
                class="c-booking-results__lbl auto-link-booking-search-results"
                >{{ record.starRating }}</span
              >
            </div>
            <!-- Our Rating Column -->
            <div class="c-result-table__data">
              <span class="lbl u-visible-xm">Our Rating</span>
              <span
                class="c-booking-results__lbl auto-link-booking-search-results"
              >
                {{ record.ourRating }}
              </span>
            </div>
            <!-- Actions -->
            <div class="c-result-table__data">
              <div class="c-tariff__download-icons">
                <svg class="a-icon u-mr-xs" surfTooltip [attr.title]="'Create PDF'" (click)="onClickDownload(record, 'PDF')">
                  <use xlink:href="#pdf"></use>
                </svg>
                <svg class="a-icon" surfTooltip [attr.title]="'Create Excel'" (click)="onClickDownload(record, 'EXCEL')">
                  <use xlink:href="#xml-logo"></use>
                </svg>
              </div>
              <span class="lbl u-visible-xm"></span>
              <span
                class="c-booking-results__lbl auto-link-booking-search-results o-table__row-item--end"
              >
              </span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!--NOTE: id should be unique for each surf-pagination-controls component when there are multiple instances since it is used to differentiate the instance inside the service.-->
    <!--Due to above reason the name of the parent component has assigned as the id.-->
    <surf-pagination-controls
      [id]="'surf-tariff-search' + componentId"
      [maxSize]="pageSize"
      (pageChange)="onPageChange($event)"
      [hasMore]="false"
      >
      <!-- (loadMore)="loadMore($event)" -->
      <!-- (emitLastPg)="emitLastPage($event)" -->
    </surf-pagination-controls>
  </div>
</div>

<div class="o-result-table__body" *ngIf="resultLoader">
  <div class="c-page-loader__animation--strip"></div>
  <div class="c-page-loader__animation--strip"></div>
  <div class="c-page-loader__animation--strip"></div>
</div>
<div
  class="no-result-page"
  *ngIf="modifiedResultList.length === 0 && resultLoader === false"
>
  <div
    class="no-result-page__wrapper"
    style="position: relative; margin: 30px 0"
  >
    <p class="no-result-page__main-title">No Results Found!</p>
    <p class="no-result-page__sub-title">
      Seems we do not have any result for given search criteria. Please refine
      your search and try again.
    </p>
  </div>
</div>
